.headerContent * {
  color: var(--c-error);
}

.code {
  width: fit-content;
  margin-bottom: 1rem;
  padding: 0.5rem;
  border-radius: var(--s-uxs);
  background: var(--c-bg-d);
}
